'use strict';

exports.__esModule = true;
exports.RULES = undefined;

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _getIterator2 = require('babel-runtime/core-js/get-iterator');

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _entries = require('babel-runtime/core-js/object/entries');

var _entries2 = _interopRequireDefault(_entries);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _isEmpty2 = require('lodash/isEmpty');

var _isEmpty3 = _interopRequireDefault(_isEmpty2);

var _map2 = require('lodash/map');

var _map3 = _interopRequireDefault(_map2);

var _every2 = require('lodash/every');

var _every3 = _interopRequireDefault(_every2);

var _isUndefined2 = require('lodash/isUndefined');

var _isUndefined3 = _interopRequireDefault(_isUndefined2);

var _negate2 = require('lodash/negate');

var _negate3 = _interopRequireDefault(_negate2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var RULES = exports.RULES = [{
  name: 'MinimumLength',
  message: function message(value) {
    return 'Must be at least ' + value + ' characters long';
  },
  test: function test(value, password) {
    return password.length >= value;
  },
  valueType: Number
}, {
  name: 'RequireNumbers',
  message: function message() {
    return 'Must include a number';
  },
  test: function test(value, password) {
    return (/\d/.test(password)
    );
  },
  valueType: Boolean
}, {
  name: 'RequireSymbols',
  message: function message() {
    return 'Must include a special character';
  },
  test: function test(value, password) {
    return (/[$^*.[\]{}()?\-"!@#%&/\\,><':;|_~`]+/.test(password)
    );
  },
  valueType: Boolean
}, {
  name: 'RequireUppercase',
  message: function message() {
    return 'Must include an uppercase letter';
  },
  test: function test(value, password) {
    return (/[A-Z]+/.test(password)
    );
  },
  valueType: Boolean
}, {
  name: 'RequireLowercase',
  message: function message() {
    return 'Must include a lowercase letter';
  },
  test: function test(value, password) {
    return (/[a-z]+/.test(password)
    );
  },
  valueType: Boolean
}, {
  name: 'DisallowLeadingAndTrailingSpaces',
  message: function message() {
    return 'Must not start or end with space';
  },
  test: function test(value, password) {
    return (/^\S+.*\S+$/.test(password)
    );
  },
  valueType: Boolean,
  static: true
}];

var PasswordValidator = function () {
  function PasswordValidator(_ref) {
    var policy = _ref.policy,
        store = _ref.store,
        getPolicyActionName = _ref.getPolicyActionName;
    (0, _classCallCheck3.default)(this, PasswordValidator);

    this.policy = policy || {};
    this.store = store;
    this.getPolicyActionName = getPolicyActionName;

    this.validate = this.validatePassword.bind(this);
    this.getMessage = this.getMessageForError.bind(this);
  }

  PasswordValidator.prototype.testPasswordAgainstPolicy = function testPasswordAgainstPolicy(password) {
    var _this = this;

    var rulesTestingResults = PasswordValidator.rules.map(function (rule) {
      var policyValue = _this.policy[rule.name];

      if (policyValue || rule.static) {
        return {
          passed: rule.test(policyValue, password),
          message: rule.message(policyValue),
          rule: rule,
          policyValue: policyValue
        };
      }
    }).filter((0, _negate3.default)(_isUndefined3.default));

    return {
      passed: (0, _every3.default)((0, _map3.default)(rulesTestingResults, 'passed')),
      results: rulesTestingResults
    };
  };

  PasswordValidator.prototype.getMessageForError = function getMessageForError(fieldName, parameters, _ref2) {
    var results = _ref2.results;

    var messages = results.filter(function (result) {
      return !result.passed;
    }).map(function (result) {
      var message = result.message;
      return 'The ' + fieldName + ' field ' + message + '.';
    });

    return messages[0];
  };

  PasswordValidator.prototype.refreshPolicy = function () {
    var _ref3 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
      var policy, _iterator, _isArray, _i, _ref5, _ref4, ruleName, value;

      return _regenerator2.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!(0, _isEmpty3.default)(this.store)) {
                _context.next = 2;
                break;
              }

              return _context.abrupt('return');

            case 2:
              _context.next = 4;
              return this.store.dispatch(this.getPolicyActionName);

            case 4:
              policy = _context.sent;
              _iterator = (0, _entries2.default)(policy), _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : (0, _getIterator3.default)(_iterator);

            case 6:
              if (!_isArray) {
                _context.next = 12;
                break;
              }

              if (!(_i >= _iterator.length)) {
                _context.next = 9;
                break;
              }

              return _context.abrupt('break', 22);

            case 9:
              _ref5 = _iterator[_i++];
              _context.next = 16;
              break;

            case 12:
              _i = _iterator.next();

              if (!_i.done) {
                _context.next = 15;
                break;
              }

              return _context.abrupt('break', 22);

            case 15:
              _ref5 = _i.value;

            case 16:
              _ref4 = _ref5;
              ruleName = _ref4[0];
              value = _ref4[1];

              this.policy[ruleName] = value;

            case 20:
              _context.next = 6;
              break;

            case 22:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function refreshPolicy() {
      return _ref3.apply(this, arguments);
    }

    return refreshPolicy;
  }();

  PasswordValidator.prototype.validatePassword = function () {
    var _ref6 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2(value) {
      var testResult;
      return _regenerator2.default.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return this.refreshPolicy();

            case 2:
              testResult = this.testPasswordAgainstPolicy(value);
              return _context2.abrupt('return', {
                valid: testResult.passed,
                data: {
                  results: testResult.results
                }
              });

            case 4:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, this);
    }));

    function validatePassword(_x) {
      return _ref6.apply(this, arguments);
    }

    return validatePassword;
  }();

  (0, _createClass3.default)(PasswordValidator, null, [{
    key: 'rules',
    get: function get() {
      return RULES;
    }
  }]);
  return PasswordValidator;
}();

exports.default = PasswordValidator;